<script>
  import { _ } from "../stores/index";
</script>

<div class="main">
  <div class="box">
    <h3 class="gl-title level-3">
      {$_("not.found.title")}
    </h3>

    <div class="text">
      <p class="mt-6 mb-2">
        {$_("not.found.text1")}
      </p>

      <p class="mt-6 mb-2">
        {$_("not.found.text2")}
      </p>
    </div>
  </div>
</div>

<style>
  .box {
    width: 774px;
    height: 353px;
    background-color: var(--gl-scheme-white);
    padding: 48px;
    border-radius: 8px;
    background-image: url("../assets/cubes-bg.svg");
    background-repeat: no-repeat;
    background-position-x: right;
  }

  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80%;
  }

  .text {
    width: 70%;
  }
</style>
